import React,{useState,useEffect} from 'react';
import styled from "@emotion/styled";
import OnSale from './OnSale';
import Sample from './Sample';
import SearchResults from './SearchResults';
import Featured from '../featured/Featured';
import OverlayComponent from '../shared/OverlayComponent';

const Layout = styled.div`
    margin-bottom: 10rem;
    display: grid;
    grid-auto-flow:row;
    align-items: center;
    justify-content: center;
    position:relative;
    //grid-template-columns: 1fr 1fr;
    //grid-template-rows: 1fr auto;
    .featured{
        width: 70rem;
    }

    @media only screen and (max-width: 768px) {
       .featured{
           position:relative;
           left: 12rem;
       }
    }
    @media only screen and (max-width: 425px) {
        .featured{
            left: 22rem;
        }
    }
    
`;
const ProductHeading = styled.div`
    margin-top: 10rem;
    margin-bottom: -8rem;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    .main-heading{
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: var(--space-40);
        line-height: var(--space-52);
        /* identical to box height, or 130% */


        /* Company Dark */

        color: #049CBE;
    }
    .sub-heading{
        width: 40rem;
        font-family: Inter,sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: var(--space-20);
        line-height: var(--space-32);
        /* or 160% */


        /* default/gray/700 */

        color: #525B64;
    }
    &:before{
        content:url(/img/side_curves.svg);
        position:absolute;
        top:15rem;
        height:60rem;
        right:-32rem;
    }
    &:after{
        content:url(/img/top_curves.svg);
        position:absolute;
        top:-6rem;
        right:39rem;
    }
    div{
        position: absolute;
        width: 220rem;
        height: 80rem;
        left: -28rem;
        top: -10rem;
        z-index:-2;
        background: #F3F5F7;
    }
    .product_background{
        width:70rem;
        position:absolute;
        top:0.7rem;
        left:-30rem;
        z-index: inherit -1;
    }

    @media only screen and (max-width: 425px) {
        .sub-heading{
            width:22rem;
        }
    }
`;
function Products() {
    const [search,setSearch] = useState(true);
    const [display,setDisplay] = useState("none");
    const [loading,setLoading] = useState(true);
    const [id,setId] = useState({
        id:"",
        name:"",
        brand:"",
        price:"",
        image:""
    });
 
    return (
        <>
       
   
        {/* {search === true ? 
        <Layout>
            
            <ProductHeading>
                <div></div>
                <img className="product_background" src="/img/product_bg.png"/>
                <h1 class="main-heading">Our Products</h1>
                <p class="sub-heading">Our comprehensive selection
                    is sure to meet all your medical supply needs,
                    complete with competitor comparisons.</p>
            </ProductHeading>
            <div class="featured">
                <Featured value={search} search={setSearch} setDisplay={setDisplay}/>
            </div>

            <Sample/>

            <OnSale/>
        </Layout>
        :
        ( */}
        <SearchResults/>
        {/* )
} */}
    
    </>
    )
}

export default Products;
